<template>
  <div class="SpCard" :style="WHstyleC">
    <div class="card-header sp-color-card-header" />
    <div class="bg-white card-content sp-color-bdl-10 sp-color-bdr-10" :class="customClass">
      <div :class="type!=='none'?'slot':'slot-none'">
        <slot>no content</slot>
      </div>
    </div>
    <div class="card-footer sp-color-bdl-1 sp-color-bdr-1 sp-color-bg-1" />
  </div>
</template>

<script type="text/ecmascript-6">
import WHcomputed from '@/mixins/WHcomputed'
export default {
  name: 'SpCard',

  nameSpace: 'SpCard',
  components: {
  },

  mixins: [WHcomputed],

  props: {
    type: {
      type: String,
      default: ''
    },

    customClass: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
    }
  }
}
</script>

<style scoped lang="less">
.SpCard{
  overflow: hidden;
  @borderWidth:3px;
  .bg-white{
    background-color: white;
  }
  >.card-header{
    width: 100%;
    height: 39px;
    position: relative;
  }
  >.card-content{
    width: 100%;
    overflow: hidden;
    border-left-width: @borderWidth;
    border-right-width: @borderWidth;
    border-left-style: dashed;
    border-right-style: dashed;
    box-sizing: border-box;
    >.slot{
      @gap:2.5%;
      width:95%;
      height:95%;
      padding: @gap @gap @gap @gap;
    }
    >.slot-none{
      width:100%;
      height:95%;
    }
  }
  >.card-footer{
    width: 100%;
    height: 21px;
    border-left-width: @borderWidth;
    border-right-width: @borderWidth;
    border-left-style: solid;
    border-right-style: solid;
  }
}
</style>
